import { type ISbStoryData } from '@storyblok/react/rsc'

import { type ContentType } from '../../storyblok'

const DEFAULT_ROBOTS_VALUE = 'index, follow, noodp'

export const storyAccessorGetSeoRobotsValueOrDefault = (
  story: ISbStoryData<ContentType>,
): string => {
  const { seoRobots } = story.content

  if (!seoRobots) {
    return DEFAULT_ROBOTS_VALUE
  }

  return seoRobots
}
